/*****************************************************************************************
 * 설명 : 페이지 서브 레이아웃
 * 작성자 :
 * 작성일 :
*****************************************************************************************/
import React, { useContext } from 'react';

import GlobalMenu from 'pages/admin/config/menuAdmin';

import Header from "pages/admin/layout/header";
import Snb from "pages/admin/layout/snb";

import './header.scss'

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const Layout = (props) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  // 축소 메뉴 표시
  const {menuReduce, setMenuReduce} = useContext(GlobalMenu);

  const toggleMenuReduce = () => {
    if (menuReduce === '') setMenuReduce('reduce');
    else setMenuReduce('');
  }

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <section className="contents-body">
      <Header toggleMenuReduce={toggleMenuReduce}></Header>

      <section className={"contents admin-contents " + menuReduce}>
        <Snb></Snb>

        {props.children}

      </section>
    </section>
  )
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default Layout;